import { InputDatev2 } from "@itandi/itandi-bb-ui/InputDatev2";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition } from "~/models/Deal";
import { toDate as convertToDate, formatHyphenDate } from "~/utils/DateUtil";

type Props = {
	attributeName:
		| "constructionMinStartDate"
		| "constructionMaxStartDate"
		| "constructionMinEndDate"
		| "constructionMaxEndDate"
		| "inspectionMinDate"
		| "inspectionMaxDate"
		| "surveyMinDate"
		| "surveyMaxDate"
		| "registrationMinDate"
		| "registrationMaxDate"
		| "updatedMinDate"
		| "updatedMaxDate"
		| "sendEstimateMinDate"
		| "sendEstimateMaxDate"
		| "orderMinDate"
		| "orderMaxDate"
		| "constructionReportedMinDate"
		| "constructionReportedMaxDate"
		| "completedMinDate"
		| "completedMaxDate";
};

export function SearchConditionDate({ attributeName }: Props) {
	const { setValue, watch } = useFormContext<DealSearchCondition>();
	const watchedValue = watch(attributeName);
	const dateValue = useMemo(
		() => convertToDate(watchedValue ?? null),
		[watchedValue]
	);

	const onDateChange = (value: Date | null): void => {
		setValue(attributeName, formatHyphenDate(value) ?? undefined);
	};
	return (
		<InputDatev2
			onChange={onDateChange}
			placeholder="年/月/日"
			value={dateValue}
		/>
	);
}
